/**
 * ESCAPE GÅR ETT STEG TILBAKE (239.50, Atle 04.10: «slik artistkortet gjør. Da virker det likt
 * overalt»).
 *
 * Et steg som åpnes INNE i en flate (delingsdialogen i vaktmodalen, «Lag ny lenke» i panelet) er ikke
 * en egen Radix-dialog, så Escape traff vinduet rundt og lukket alt. Steget melder seg her mens det
 * står; `Modal` spør registeret når Radix sier Escape, og et registrert steg tar tastetrykket i stedet
 * for vinduet. Radix sender Escape bare til det øverste laget, så en åpen nedtrekksliste eller
 * datovelger lukker seg selv først, som før.
 *
 * Et modulregister og ikke en kontekst, av samme grunn som `modal-nesting.ts`: stegene står ofte i en
 * portal ved siden av vinduet, ikke under det i treet. Det sist registrerte steget er det innerste.
 */
const steps: Array<() => void> = [];

/** Registrerer et steg; svaret fjerner det igjen. */
export function pushEscapeStep(step: () => void): () => void {
  steps.push(step);
  return () => {
    const index = steps.lastIndexOf(step);
    if (index >= 0) steps.splice(index, 1);
  };
}

/** Kjører det innerste steget. `true` når et steg tok tastetrykket. */
export function runEscapeStep(): boolean {
  const step = steps[steps.length - 1];
  if (step === undefined) return false;
  step();
  return true;
}
